import React from 'react';

export default () => (
  <svg width="17" height="17" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.5 0A8.503 8.503 0 0 0 0 8.5C0 13.192 3.808 17 8.5 17S17 13.192 17 8.5 13.192 0 8.5 0zm.85 12.75h-1.7v-5.1h1.7v5.1zm0-6.8h-1.7v-1.7h1.7v1.7z"
      fill="#3C80CF"
      fillRule="evenodd"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/info.es6.js